/**
 * Limit-based scopes
 */
export const WORKFLOWS_ENTERPRISE_LIMITS = 'workflows-enterprise-limits';

/**
 * Feature-based scopes
 */
export const EDIT_WORKFLOW = 'workflows-edit-team-owned';

/**
 * Ops-hub scopes
 */
export const CUSTOM_CODE_ACCESS = 'workflows-custom-code-access';
export const FORMAT_DATA_ACCESS = 'workflows-format-data-access';
export const SCHEDULED_ENROLLMENT_ACCESS = 'automation-scheduled-enrollment-access';
export const WEBHOOK_ACCESS = 'workflows-webhook-access';

/**
 * Commerce scopes
 */
export const COMMERCE_PAYMENTS_ACCESS = 'commerce-payments-access';
export const COMMERCE_PAYMENTS_READ = 'commerce-payments-read';
export const SUBSCRIPTIONS_ACCESS = 'subscriptions-access';

/*Super admin */
export const SUPER_ADMIN = 'super-admin';